module.exports = "/fonts/fa-regular-400.woff2?e07d9e40b26048d9abe2ef966cd6e263";